import { History } from 'history';
import 'moment/locale/lt';
import React from 'react';
import { Outlet, Route, Routes, unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthenticationContextProvider } from './components';
import { DialogContextProvider } from './components/dialogs';
import { AppLayout, OrganizationLayout, QueueLayout } from './components/layout/AdministrationRoute';
import { WindowContextProvider } from './components/windows/WindowContext';
import {
    AdministrationPage,
    DevicesPage,
    GeneralSettingsPage,
    HomePage,
    LocationsPage,
    LogoutPage,
    NotFoundPage,
    OrganizationPage,
    QueuesPage,
    ServicesGroupsPage,
    StatisticsPage,
    WizardPage
} from './features';
import DoorScreenDisplayPage from './features/display/doorScreen/DoorScreenDisplayPage';
import InfoScreenDisplayPage from './features/display/infoScreen/InfoScreenDisplayPage';
import QueueManagement from './features/queueManagement/components/QueueManagement';
import RegistrationPage from './features/registration/RegistrationPage';

interface AppProps {
    history: History;
}

class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render() {
        const { history } = this.props;
        return (
            <div>
                <ToastContainer theme="colored" />
                <DialogContextProvider>
                    <WindowContextProvider>
                        <HistoryRouter history={history} basename={process.env.PUBLIC_URL}>
                            <Routes>
                                <Route path="/display/doorScreen/:doorScreenId" element={<DoorScreenDisplayPage />} />
                                <Route path="/display/infoScreen/:infoScreenId" element={<InfoScreenDisplayPage />} />
                                <Route path="/reg" element={<RegistrationPage />} />
                                <Route path="/logout" element={<LogoutPage />} />

                                <Route element={<AuthenticationContextProvider children={<Outlet />} />}>
                                    <Route
                                        path="/queuesManagement"
                                        element={
                                            <QueueLayout>
                                                <QueueManagement />
                                            </QueueLayout>
                                        }
                                    />
                                    <Route
                                        path="/"
                                        element={
                                            <AppLayout>
                                                <HomePage />
                                            </AppLayout>
                                        }
                                    />
                                    <Route
                                        path="/administration"
                                        element={
                                            <OrganizationLayout>
                                                <AdministrationPage />
                                            </OrganizationLayout>
                                        }
                                    />

                                    <Route
                                        path="/administration/organization/:organizationInformationId/wizard"
                                        element={
                                            <OrganizationLayout>
                                                <WizardPage />
                                            </OrganizationLayout>
                                        }
                                    />
                                    <Route
                                        path="/administration/organization/:organizationInformationId/information"
                                        element={
                                            <OrganizationLayout>
                                                <OrganizationPage />
                                            </OrganizationLayout>
                                        }
                                    />
                                    <Route
                                        path="/administration/organization/:organizationInformationId/devices"
                                        element={
                                            <OrganizationLayout>
                                                <DevicesPage />
                                            </OrganizationLayout>
                                        }
                                    />
                                    <Route
                                        path="/administration/organization/:organizationInformationId/locations"
                                        element={
                                            <OrganizationLayout>
                                                <LocationsPage />
                                            </OrganizationLayout>
                                        }
                                    />
                                    <Route
                                        path="/administration/organization/:organizationInformationId/queues"
                                        element={
                                            <OrganizationLayout>
                                                <QueuesPage />
                                            </OrganizationLayout>
                                        }
                                    />
                                    <Route
                                        path="/administration/organization/:organizationInformationId/services"
                                        element={
                                            <OrganizationLayout>
                                                <ServicesGroupsPage />
                                            </OrganizationLayout>
                                        }
                                    />
                                    <Route
                                        path="/administration/organization/:organizationInformationId/generalSettings"
                                        element={
                                            <OrganizationLayout>
                                                <GeneralSettingsPage />
                                            </OrganizationLayout>
                                        }
                                    />
                                    <Route
                                        path="/statistics/:type"
                                        element={
                                            <AppLayout>
                                                <StatisticsPage />
                                            </AppLayout>
                                        }
                                    />
                                    <Route
                                        element={
                                            <AppLayout>
                                                <NotFoundPage />
                                            </AppLayout>
                                        }
                                    />
                                </Route>
                            </Routes>
                        </HistoryRouter>
                    </WindowContextProvider>
                </DialogContextProvider>
            </div>
        );
    }
}

export default App;
